import { Link } from 'react-router-dom';
import { AuthContext } from '../../contexts/auth';
import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { AiOutlineDashboard } from 'react-icons/ai';
import { FaArrowTrendDown, FaFileImport } from 'react-icons/fa6';
import { GiExitDoor, GiMineTruck, GiGoldMine} from 'react-icons/gi';
import { BsBox } from 'react-icons/bs';
import { FaMicroscope, FaOilCan } from 'react-icons/fa';
import { CgFileDocument } from 'react-icons/cg';
import { MdSecurity } from 'react-icons/md';
import './menu.css';

export default function Menu(){
  const { signOut, permissoes, ligaMenu } = useContext(AuthContext);
  const navegar = useNavigate();
      
  if (ligaMenu) {
    return(
	<aside className='md:border-r md:border-b-0 border-b border-secondary border-opacity-50'>
	  <button className='w-full md:hidden flex justify-start items-center py-2 px-4 bg-primary-300 menu-mobile'>
		<i className="fa fa-bars"></i>
		<span className='block ml-3 font-semibold'>Menu</span>
	  </button>

	  <div className="menu-container md:block hidden">
		<div className='grid-cols-1 gap-4 p-4 inline-grid'>
		  <div>
			{(permissoes.includes("DASHBOARD_CONSULTAR")) && (
			  <div><Link to='/dashboard'>Dashboard</Link></div>
			)}

			{(permissoes.includes("IMPORTAR_ARQUIVO")) && (
			  <div><Link to='/uploadzip'>Importar Arquivo</Link></div>
			)}

			{(permissoes.includes("CONCEDER_PERMISSÃO")) && (
			  <div>
				<Link to='/gerarsenha'>Conceder Permissão</Link>
			  </div>
			)}

			{(permissoes.includes("CLIENTE_CONSULTAR")) && (
			  <div>
				<Link to='/clientes'>Clientes</Link>
			  </div>
			)}

			{(permissoes.includes("DESVIO_CONSULTAR")) && (
			  <div>
				<Link to='/desvios'>Desvios</Link>
			  </div>
			)}

			{(permissoes.includes("FLUIDO_CONSULTAR")) && (
			  <div>
				<Link to='/fluidos'>Fluidos</Link>
			  </div>
			)}

			{(permissoes.includes("EQUIPAMENTO_CONSULTAR")) && (
			  <div>
				<Link to='/equipamentos'>Equipamentos</Link>
			  </div>
			)}

			{(permissoes.includes("COMPARTIMENTO_CONSULTAR")) && (
			  <div>
				<Link to='/compartimentos'>Compartimentos</Link>
			  </div>
			)}

			{(permissoes.includes("ORDEM_CONSULTAR")) && (
			  <div>
				<Link to='/ordens'>Ordem de Manutenção</Link>
			  </div>
			)}

			{(permissoes.includes("RELATÓRIO_DESCONTAMINADOS_GERAR")) && (
			  <div>
				<Link to='/relatorios'>Relatórios</Link>
			  </div>
			)}

		  </div>
		  <button className='botaosair' onClick={signOut} >Sair</button>
		</div>
	  </div>
	</aside>

    );

  } else {

  return(
    <aside className='md:border-r md:border-b-0 border-b border-secondary border-opacity-50 w-20'>
      <button className='w-full md:hidden flex justify-start items-center py-2 px-4 bg-primary-300 menu-mobile'>
        <i className="fa fa-bars"></i>
        <span className='block ml-3 font-semibold'>Menu</span>
      </button>

      <div className="menu-container md:block hidden">
        <div className='grid-cols-1 gap-4 p-4 inline-grid'>
          <div>
            {(permissoes.includes("DASHBOARD_CONSULTAR")) && (
              <div className='icone'>
                <button className='action' onClick={()=> navegar("/dashboard")} title="Dashboard">
                  <AiOutlineDashboard size={25} color="rgb(0, 61, 45)" title="Dashboard"/>
                </button>
              </div>
            )}

            {(permissoes.includes("IMPORTAR_ARQUIVO")) && (
              <div className='icone'>
                <button className='action' onClick={()=> navegar("/uploadzip")}>
                  <FaFileImport size={25} color="rgb(0, 61, 45)" title="Importar Arquivos"/>
                </button>
              </div>
            )}

            {(permissoes.includes("CONCEDER_PERMISSÃO")) && (
              <div className='icone'>
                <button className='action' onClick={()=> navegar("/gerarsenha")}>
                  <MdSecurity size={25} color="rgb(0, 61, 45)" title="Conceder Permissão"/>
                </button>
              </div>
            )}

            {(permissoes.includes("CLIENTE_CONSULTAR")) && (
              <div className='icone'>
                <button className='action' onClick={()=> navegar("/clientes")}>
                  <GiGoldMine size={25} color="rgb(0, 61, 45)" title="Clientes"/>
                </button>
              </div>
            )}

            {(permissoes.includes("DESVIO_CONSULTAR")) && (
              <div className='icone'>
                <button className='action' onClick={()=> navegar("/desvios")}>
                  <FaArrowTrendDown size={25} color="rgb(0, 61, 45)" title="Desvios"/>
                </button>
              </div>
            )}

            {(permissoes.includes("FLUIDO_CONSULTAR")) && (
              <div className='icone'>
                <button className='action' onClick={()=> navegar("/fluidos")}>
                  <FaOilCan size={25} color="rgb(0, 61, 45)" title="Fluidos"/>
                </button>
              </div>
            )}

            {(permissoes.includes("EQUIPAMENTO_CONSULTAR")) && (
              <div className='icone'>
                <button className='action' onClick={()=> navegar("/equipamentos")}>
                  <GiMineTruck size={25} color="rgb(0, 61, 45)" title="Equipamentos"/>
                </button>
              </div>
            )}

            {(permissoes.includes("COMPARTIMENTO_CONSULTAR")) && (
              <div className='icone'>
                <button className='action' onClick={()=> navegar("/compartimentos")}>
                  <BsBox size={25} color="rgb(0, 61, 45)" title="Compartimentos"/>
                </button>
              </div>
            )}

            {(permissoes.includes("ORDEM_CONSULTAR")) && (
              <div className='icone'>
                <button className='action' onClick={()=> navegar("/ordens")}>
                  <FaMicroscope size={25} color="rgb(0, 61, 45)" title="Ordem de Manutenção"/>
                </button>
              </div>
            )}

            {(permissoes.includes("RELATÓRIO_DESCONTAMINADOS_GERAR")) && (
              <div className='icone'>
                <button className='action' onClick={()=> navegar("/relatorios")}>
                  <CgFileDocument size={25} color="rgb(0, 61, 45)" title="Relatórios"/>
                </button>
              </div>
            )}
          </div>
          <div className='icone'>
            <button className='botaosair' onClick={signOut} >
              <GiExitDoor size={25} color="rgb(0, 61, 45)" title="Sair"/>
            </button>
          </div>
        </div>
      </div>
    </aside>
  )
  }
}
